<template lang="pug">
global-form-group(:title="field.title" :field-name="field.name")
	input
	div.desc {{ field.description }}
</template>

<script>
	import GlobalFormGroup from "../../GlobalFormGroup";
	export default  {
		name: "Location",
		components: {GlobalFormGroup},
		props: {
			field: {

			}
		}
	}
</script>
